import React, { createContext, useState, useEffect } from "react";
import "./style.scss";
import Gallery from "./components/Gallery";
import Header from "./components/Header";
import Gadgets from "./components/steps/Gadgets";
import Inside from "./components/steps/Inside";
import Outside from "./components/steps/Outside";
import Overview from "./components/steps/Overview";
import Seats from "./components/steps/Seats";
import Tech from "./components/steps/Tech";

import config from "./config.json";

import { decode as b64decode } from "base-64";

export const ConfigContext = createContext( config );
export const CurrentContext = createContext<Record<string, any>>( {} );
export const SetterContext = createContext( ( key: string ) => ( value: any ) => {
} );
export const StepContext = createContext<[ number, ( step: number ) => void ]>( [ 0, step => {
} ] );

export const lengthToType = ( length: string ) => {
    return length === "5,99m" ? "l3h2" : "l2h2";
};


declare global {
    interface Window {
        chrome: any;
    }
}

function App() {

    // Allow only DESKTOP firefox, safari, opera
    const isChromium = typeof window !== "undefined" && !!window.chrome;
    const winNav = window.navigator;
    const userAgent = winNav.userAgent.toLowerCase();
    const vendorName = winNav.vendor;
    const isOpera = userAgent.indexOf( "opr" ) > -1 || userAgent.indexOf( "opera" ) > -1;
    const isIEedge = userAgent.indexOf( "edge" ) > -1 || userAgent.indexOf( "edg" ) > -1;
    const isIOSChrome = userAgent.match( "crios" );
    const isMobile = /iphone|ipod|ipad|android|mobile/i.test( userAgent );
    const isFirefox = userAgent.indexOf( "firefox" ) > -1;
    const isSafari = /^((?!chrome|android).)*safari/i.test( userAgent ) && vendorName === "Apple Computer, Inc.";

    // Debug-Ausgabe zur Überprüfung der Variablen
    // 	console.log("isChromium:", isChromium);
    // 	console.log("isFirefox:", isFirefox);
    // 	console.log("isSafari:", isSafari);
    // 	console.log("isMobile:", isMobile);

    if ( isMobile ) {
        window.location.href = "https://vanchanger.de/html/wrongdevice.html";
    }

    const [ step, setStep ] = useState( 0 );

    const currentURL = new URL( window.location.href );
    const configString = currentURL.searchParams.get( "config" );
    const initialConfig = configString ? JSON.parse( b64decode( configString ) ) : {
        "length": "5,40m",
        "engine": "140 PS",
        "transmission": "Manuell",
        "package": "Car Essential",
        "outside_color": "Cassablanca Weiß",
        "inside_version": "Basic Camper",
        "inside_color": "beige",
        "tech_package": "Technik Essential",
        "tech_optional": [],
        "gadgets": [],
        "modules": [],
        "seats": "0",
    };

    const [ current, setCurrent ] = useState( initialConfig );


    if ( configString ) {
        currentURL.searchParams.delete( "config" );
        window.history.replaceState( null, "unused", currentURL.href );
    }


    const createConfigSetter = ( ( key: string ) => ( value: any ) => setCurrent( { ...current, [key]: value } ) );

    return (
            <CurrentContext.Provider value={current}>
                <SetterContext.Provider value={createConfigSetter}>
                    <StepContext.Provider value={[ step, setStep ]}>
                        <div className={"wrapper"}>
                            <Header />
                            <main className="flex configurator-container">

                                {/*JSON.stringify( config ) */}
                                {/*JSON.stringify( current )*/}

                                {/*<!-- Bereich Bildergalerie -->*/}
                                <Gallery />

                                {/*<!-- Bereich Konfiguration -->*/}
                                <div className="flex configuration-side">
                                    <div className="flex configuration-wrapper">
                                        {step === 0 && <Outside />}
                                        {step === 1 && <Inside />}
                                        {step === 2 && <Seats />}
                                        {step === 3 && <Tech />}
                                        {step === 4 && <Gadgets />}
                                        {step === 5 && <Overview />}

                                        {/*<!-- Gesamtsumme anzeigen -->*/}

                                        <div className="configurator-bottom-spacer"></div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </StepContext.Provider>
                </SetterContext.Provider>
            </CurrentContext.Provider>
    );
}

export default App;
